import {MwSmallIcon} from "./icons";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import '../v2/styles/_get-a-demo.module.scss';

const OurCareerCTA = () => {
    const { t } = useTranslation('common');
    const careerCTAData = t('aboutUs.careerCTA', { returnObjects: true, defaultValue: {} }) as any;
    
    return (
        <>
            <div className={"our-career-cta"}>
                <div className={"container"}>
                    <div className={"career-cta"}>
                        <div className={'section-tag testimonial pd-right'}><MwSmallIcon/>{String(careerCTAData?.sectionTag ?? '')}</div>
                        <h2>
                            {String(careerCTAData?.titlePrefix ?? '')}
                            <span className={"text-gradient"}> {String(careerCTAData?.titleHighlight ?? '')}</span>
                        </h2>
                        <p dangerouslySetInnerHTML={{ __html: String(careerCTAData?.description ?? '') }}></p>
                        <Link href={String(careerCTAData?.cta?.link ?? '')}>
                            <div className={"get-a-demo icon"}>{String(careerCTAData?.cta?.text ?? '')}</div>
                        </Link>
                    </div>
                </div>
            </div>

        </>
    )
}

export default OurCareerCTA;